// =======================================
// HBD Converter v3.0
// siddhidatri.com
// Manual Exchange Rates
// =======================================

document.addEventListener("DOMContentLoaded", function () {

    console.log("HBD Converter Started");

    let hbdMode = false;

    // ====================================================
    // Manual Exchange Rates
    // Change these whenever you want
    // ====================================================

    const rates = {
        INR: 92,
        USD: 1,
        EUR: 1.17,
        GBP: 1.36,
        AUD: 0.66,
        CAD: 0.73,
        SGD: 0.79,
        AED: 0.272,
        JPY: 0.0067
    };

    const currentCurrency =
        (window.Shopify &&
        Shopify.currency &&
        Shopify.currency.active)
            ? Shopify.currency.active
            : "USD";

    console.log("Current Currency:", currentCurrency);

    const header = document.querySelector(".header__icons");

    if (!header) return;

    const btn = document.createElement("button");

    btn.id = "hbd-toggle";
    btn.innerHTML = "HBD";

    btn.style.marginRight = "10px";
    btn.style.padding = "8px 14px";
    btn.style.borderRadius = "20px";
    btn.style.cursor = "pointer";

    header.prepend(btn);

    btn.addEventListener("click", function () {

        hbdMode = !hbdMode;

        const prices = document.querySelectorAll(".money.buckscc-money");

        prices.forEach(function (el) {

            if (!el.dataset.original) {
                el.dataset.original = el.textContent.trim();
            }

            if (hbdMode) {

                let original = el.dataset.original;

                let value = parseFloat(
                    original
                        .replace(/,/g, "")
                        .replace(/[^\d.]/g, "")
                );

                if (isNaN(value)) return;

                let hbd = value;

                switch (currentCurrency) {

                    case "INR":
                        hbd = value / rates.INR;
                        break;

                    case "USD":
                        hbd = value;
                        break;

                    case "EUR":
                        hbd = value * rates.EUR;
                        break;

                    case "GBP":
                        hbd = value * rates.GBP;
                        break;

                    case "AUD":
                        hbd = value * rates.AUD;
                        break;

                    case "CAD":
                        hbd = value * rates.CAD;
                        break;

                    case "SGD":
                        hbd = value * rates.SGD;
                        break;

                    case "AED":
                        hbd = value * rates.AED;
                        break;

                    case "JPY":
                        hbd = value * rates.JPY;
                        break;

                    default:
                        hbd = value;
                }

                el.innerHTML = hbd.toFixed(2) + " HBD";

            } else {

                el.innerHTML = el.dataset.original;

            }

        });

    });

});